export const locale = {
  lang: 'de',
  data: {
    'NOTIFICACIONES': {
      'INFO': {
        'HOY': 'Heute',
        'TITUNOT': 'Benachrichtigungen',
        'NOTTTIP': 'Als gelesen markieren'
      },
      'EDITOR_EMAILS': {
        'NUEVAMOD': 'Die Firma <b>-ALVPRRO-</b> hat eine Änderung an einer oder mehreren ihrer Kommunikations-E-Mails vorgenommen',
        'NUEVAMODS': 'Ein Projektleiter hat eine Änderung an einer oder mehreren Kommunikations-E-Mails für die Firma <b>-ALVPRRO-</b> vorgenommen'
      },
      'AUTORI-ENCUESTA': {
        'AUTORIZAR-ENCUESTA': 'Die Firma <b>-ALVPRRO-</b> hat zur Autorisierung der Umfrage gesendet',
      },
    },
    'NOTIFICACION_PRODUCT':{
      'PRODUCTOS_ID':{
        '20':'Zertifizieren',
        '40':'Zertifizieren 3.0',
        '41':'Messen 3.0',
        '42':'Pulsecheck 3.0',
        '43':'Fokusbereich',
        '63':'NOM-035 v3.0',
      },
      'TIPO_MENSAJE_MOSTRAR':{
        'languageNative':'Sie haben die Hauptsprache ausgewählt',
        'sinAdicionales':'Sie haben keine zusätzlichen Sprachen ausgewählt',
        'languageAdittional':'Sie haben die zusätzlichen Sprachen ausgewählt',
        'conAdicionales':'Sie haben das Häkchen ohne zusätzliche Sprachen entfernt',
        'deleteLangNative':'Sie haben die Muttersprache gelöscht',
        'completePasLang':'Sie haben den Sprachschritt abgeschlossen',
        'completePasTemplate':'Sie haben den Schritt Template abgeschlossen',
        'completePasReacti': 'Sie haben den Reagenzienschritt abgeschlossen',
        'completePasNps': 'Sie haben den nps-Schritt abgeschlossen',
        'completePasControl': 'Sie haben den Kontrollschritt abgeschlossen',
        'completePasDemogra': 'Sie haben den Demografieschritt abgeschlossen',
        'completePasAbierta': 'Sie haben den offenen Schritt abgeschlossen',
        'completePasAdicio': 'Sie haben den zusätzlichen Schritt abgeschlossen',
        'completePas4all': 'Sie haben den forall-Schritt abgeschlossen',
        'completePasEncues': 'Sie haben den Schritt "Umfrage" abgeschlossen',
        'completePasColab': 'Sie haben den Schritt Kollaborateure abgeschlossen',
        'completePasEnvi': 'Sie haben den Schritt "Senden" abgeschlossen',
        'completePasEstat': 'Sie haben den Schritt Umfragestatus abgeschlossen',
        'completePasProgra': 'Sie haben den Programmierschritt abgeschlossen',
        'DescompletePasLang': 'Sie haben den Sprachschritt dekomplettiert',
        'DescompletePasTemplate': 'Sie haben den Vorlagenschritt dekomplettiert',
        'DescompletePasReacti': 'Sie haben den Reagenzienschritt unvollständig ausgeführt',
        'DescompletePasNps': 'Sie haben den nps-Schritt unvollständig ausgeführt',
        'DescompletePasControl': 'Sie haben den Kontrollschritt unvollständig ausgeführt',
        'DescompletePasDemogra': 'Sie haben den Demographieschritt unvollständig ausgeführt',
        'DescompletePasAbierta': 'Sie haben den offenen Schritt unvollständig ausgeführt',
        'DescompletePasAdicio': 'Sie haben den zusätzlichen Schritt unvollständig ausgeführt',
        'DescompletePas4all': 'Sie haben den Forall-Schritt unvollständig ausgeführt',
        'DescompletePasEncues': 'Sie haben den Schritt "Umfrage" nicht abgeschlossen',
        'DescompletePasColab': 'Sie haben den Schritt Kollaborateure unvollständig ausgeführt',
        'DescompletePasEnvi': 'Sie haben den Schritt Senden unvollständig ausgeführt',
        'DescompletePasEstat': 'Sie haben den Schritt Vermessungsstatus unvollständig ausgeführt',
        'DescompletePasProgra': 'Sie haben den Schritt Programmierung nicht abgeschlossen',
        'createSurvey': 'Umfrage wurde erstellt',
        'saveUserDemo': 'Sie haben die Demo-Benutzer in der Umfrage gespeichert',
        'recreateSurvey': 'Die Umfrage wurde neu erstellt',
        'saveSeccionNps': 'Der nps-Abschnitt wurde in der Umfrage gespeichert',
        'saveSeccionReactivos': 'Der Reagenzien-Abschnitt wurde in der Umfrage gespeichert',
        'saveSeccionControl': 'Der Steuerabschnitt wurde in der Umfrage gespeichert',
        'saveSeccionDemogra': 'Der Demographie-Abschnitt wurde in der Umfrage gespeichert',
        'saveSeccionAbier': 'Der offene Abschnitt wurde in der Umfrage gespeichert',
        'saveSeccionForall': 'Der Forall-Abschnitt wurde in der Umfrage gespeichert',
        'saveSeccionAdicio': 'Der zusätzliche Abschnitt wurde in der Umfrage gespeichert',
        'subBaseColab': 'Die Beitragszahlerbasis wurde hochgeladen',
        'downloadBaseColab': 'Die Beitragszahlerbasis wurde heruntergeladen',
        'deleteBaseColab': 'Die Mitwirkerbasis wurde gelöscht',
        'saveUsersSurvey': 'Die Mitwirkenden der Umfrage wurden gespeichert',
        'regisFechaLanza': 'Das Startdatum der Umfrage wurde erfasst',
        'regisFechaAviso1': 'Das Datum der Benachrichtigung 1 vor der Umfrage wurde aufgezeichnet',
        'regisFechaAviso2': 'Das Datum der Warnung 2 vor der Umfrage wurde aufgezeichnet',
        'saveRecordatorioEncu': 'Es wurde eine Erinnerung aufgezeichnet',
        'enviarCorreos': 'Sie haben ausgewählt, eine E-Mail an Ihre Mitarbeiter zu senden',
        'noEnviarCorreos': 'Sie haben ausgewählt, die Mail nicht an Ihre Mitarbeiter zu senden',
        'cambiarEstatusCorreo': 'Sie haben die Änderung vorgenommen, um den Versand von Mails zu modifizieren',
        'ActivaEstatEncu': 'Die Umfrage wurde aktiviert',
        'DesacEstatEncu': 'Die Umfrage wurde deaktiviert',
        'activoSeccionNps':'Der NPS-Bereich wurde für die Umfrage aktiviert',
        'desActivoSeccionNps':'Der NPS-Abschnitt wurde für die Umfrage deaktiviert',
        'activoSeccionReactivos':'Der REACTIVE-Abschnitt wurde für die Umfrage aktiviert',
        'desActivoSeccionReactivos':'Der REACTIVOS-Abschnitt wurde für die Umfrage deaktiviert',
        'activoSeccionControl':'Der CONTROL-Abschnitt wurde für die Umfrage aktiviert',
        'desActivoSeccionControl':'Der CONTROL-Abschnitt wurde für die Umfrage deaktiviert',
        'activoSeccionDemograficos':'Der Abschnitt DEMOGRAPHICS wurde für die Umfrage aktiviert',
        'desActivoSeccionDemograficos':'Der Abschnitt DEMOGRAPHICS wurde für die Umfrage deaktiviert',
        'activoSeccionAbiertas':'Der Abschnitt OPEN wurde für die Umfrage aktiviert',
        'desActivoSeccionAbiertas':'Der Abschnitt ABIERTAS para la encuesta wurde deaktiviert',
        'activoSeccionForall':'Der Abschnitt FORALL wurde für die Umfrage aktiviert',
        'desActivoSeccionForall':'Der Abschnitt FORALL wurde für die Umfrage deaktiviert',
        'activoSeccionAdicionales':'Der Abschnitt ADDITIONAL wurde für die Umfrage aktiviert',
        'desActivoSeccionAdicionales':'Der Abschnitt ADDITIONAL wurde für die Umfrage deaktiviert',
        'deletePregTemNps':'Die Frage wurde aus dem NPS-Bereich gelöscht',
        'deletePregTemReacti':'Die Frage wurde aus dem Abschnitt REACTIVES gelöscht',
        'deletePregTemControl':'Die Frage wurde aus dem Abschnitt CONTROL gelöscht',
        'deletePregTemDemogra':'Die Frage wurde aus dem Abschnitt DEMOGRAPHICS gelöscht',
        'deletePregTemAbier':'Die Frage wurde aus dem Abschnitt OPEN gelöscht',
        'deletePregTemAdici':'Die Frage wurde aus dem Abschnitt ADDITIONAL gelöscht',
        'savePregCatNps':'Die Katalogfrage wurde im NPS-Bereich gespeichert',
        'savePregCatReacti':'Die Katalogfrage wurde in den Bereich REAGENTS gespeichert',
        'savePregCatControl':'Die Katalogfrage wurde in den Bereich CONTROL gespeichert',
        'savePregCatDemogra':'Die Katalogfrage wurde im Bereich DEMOGRAPHICS gespeichert',
        'savePregCatAbier':'Die Katalogfrage wurde in den Abschnitt OPEN gespeichert',
        'savePregCatAdici':'Die Katalogfrage wurde im Abschnitt ADDITIONALS gespeichert',
        'savePregNueNps':'Neue Frage wurde in den NPS-Bereich gespeichert',
        'savePregNueReacti':'Neue Frage wurde im Abschnitt REAGENTS gespeichert',
        'savePregNueControl':'Die neue Frage wurde im Abschnitt CONTROL gespeichert',
        'savePregNueDemogra':'Neue Frage wurde in der Sektion DEMOGRAPHIE gespeichert',
        'savePregNueAbier':'Neue Frage wurde in der Sektion OPEN gespeichert',
        'savePregNueAdici':'Neue Frage wurde in der Sektion ADDITIONALS gespeichert',
        'editPregNps':'Die Frage wurde im NPS-Abschnitt bearbeitet',
        'editPregReacti':'Frage im Abschnitt REAGENTS wurde bearbeitet',
        'editPregControl':'Frage im Abschnitt CONTROL wurde editiert',
        'editPregDemogra':'Frage im Abschnitt DEMOGRAPHICS wurde bearbeitet',
        'editPregAbier':'Frage im Abschnitt OPEN wurde bearbeitet',
        'editPregAdici':'Frage im Abschnitt ADDITIONAL wurde editiert',
        'LogOut':'Sie sind abgemeldet',
        'reiniciarLang':'Sie haben das Produkt neu gestartet',
        'accionText':'',
        'updatCuesForall':'The questionnaire of the forall section has been updated.',
        'savePracticaForall':'Die Praxis für alle wurde gespeichert',
        'saveDescripForall':'Die Beschreibung der Praxis für alle wurde gespeichert.',

      },
      'BTN_MOSTRAR_HISTO':'Historie anzeigen',
      'ETI_PRODUC':'Produkt:',
      'TITLE_HISTO_PROD':'Produkthistorie',
      'CARG_INFOR':'Ladeinformation',
      'TITLE_FILTER':'Filter:',
      'DELETE_FILTER':'Filter löschen',
      'FILTER_1':'Datum:',
      'BUSCAR_FILTER':'Suchen',
      'TH_TITTLE':'Produkthistorie',
      'BTN_FILTER_HISTO':'Filter Historie',
      'TD_USUARIO':'Benutzer:',
      'TD_FECHA_PRODU':'Produktdatum:',
      'TD_TIPO_PRODU':'Produkttyp:',
      'TD_TIPO_USU_ADMI':'Administrator-Benutzer',
      'WARNING_NO_DATOS':'Keine Informationen zum Anzeigen',

    }
  }
};
